
import { computed, defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

import useNotifications from '@/common/composable/useNotifications'
import { pvz } from '@/core/realisations/pvz.realisation'

export default defineComponent({
    components: { Modal, TheInput },
    props: {
        pvzId: {
            type: Number,
            required: true,
        },
    },
    emits: ['create', 'update', 'cancel'],
    setup(props, { emit }) {
        const { notifyError } = useNotifications()

        const state = reactive({
            name: null as string | null,
            email: null as string | null,
            password: null as string | null,
            phone: null as string | null,
            is_loading: false,
        })

        const state_form$ = useVuelidate(
            {
                name: { required },
                email: { required, email },
                password: { required },
                phone: { required },
            },
            state
        )

        const emitCancel = () => {
            emit('cancel')
        }

        const createUser = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const payload = {
                    name: state.name,
                    email: state.email,
                    phone: state.phone,
                    password: state.password,
                    isAdmin: 1,
                }

                await pvz.addUser(props.pvzId, payload)

                emitCancel()
            } catch (error) {
                notifyError({ error, title: 'При создании администратора произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return { state, state_form$, emitCancel, createUser }
    },
})
